import { Workflow, CheckCheck, ShieldCheck, Sparkles } from "lucide-react";

const BLOCKS = [
  {
    key: "unified-workflow",
    icon: Workflow,
    title: "Unified Workflow Authority",
    desc: "Stop jumping between 20 tabs. We bridge the world's leading libraries into a single, high-status dashboard. You manage your entire global supply chain from one search bar.",
  },
  {
    key: "instant-approval",
    icon: CheckCheck,
    title: "Instant Client Approval (SyncBoard™)",
    desc: "Eliminate unbillable production hours. Our private, live-sync workspace allows your clients to review and approve assets in 60 seconds, cutting your campaign feedback loops by 70%.",
  },
  {
    key: "ip-governance",
    icon: ShieldCheck,
    title: "Total IP Governance (Universal Rights Wallet™)",
    desc: "Protect your brand from legal friction. We provide a centralized, 100% auditable legal trail for every license you own. One dashboard, every certificate, total indemnification.",
  },
  {
    key: "visual-exclusivity",
    icon: Sparkles,
    title: "Visual Exclusivity (Elite Intelligence™)",
    desc: "Avoid the \"generic\" trap. Our proprietary data highlighting \"Market Intensity\" ensures you only license \"Fresh\" content, preventing your hero visuals from overlapping with competitor campaigns.",
  },
];

export default function WhyAgencies() {
  return (
    <section
      data-testid="why-agencies"
      className="bg-white text-ink border-y border-border"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-10 md:py-12">
        <div className="max-w-2xl mb-6 md:mb-8">
          <div className="text-[11px] uppercase tracking-[0.35em] text-gold mb-2">The EliteStock Advantage</div>
          <h2 className="font-serif text-2xl md:text-3xl leading-[1.1] text-ink">The Elite Standard: Why Global Agencies Choose Us</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-border">
          {BLOCKS.map((b, i) => {
            const Icon = b.icon;
            return (
              <article
                key={b.key}
                data-testid={`why-block-${b.key}`}
                className="group relative bg-white p-5 md:p-6 hover:bg-muted/30 transition-colors"
              >
                <div className="flex items-start gap-4">
                  <div className="shrink-0">
                    <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold/40 flex items-center justify-center group-hover:bg-gold/20 transition-colors">
                      <Icon className="h-4.5 w-4.5 text-gold" strokeWidth={1.6} />
                    </div>
                    <div className="mt-2 text-[10px] uppercase tracking-[0.35em] text-gold/80 pl-0.5">
                      — {String(i + 1).padStart(2, "0")}
                    </div>
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-serif text-lg md:text-xl leading-tight text-ink">{b.title}</h3>
                    <p className="mt-2 text-[13.5px] leading-relaxed text-muted-foreground">{b.desc}</p>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
